import React, { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ShareDropdown = ({ visible, onClose, url }) => {
  const ref = useRef();
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    };

    if (visible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div
      ref={ref}
      className="absolute top-8 -left-60 w-[320px] bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md shadow-lg z-50 p-4"
    >
      <div className="text-sm font-semibold text-gray-800 dark:text-gray-100 mb-2">
        {t("Doküman Bağlantısı")}
      </div>
      <div className="flex items-center bg-gray-100 dark:bg-gray-800 rounded-md border border-gray-300 dark:border-gray-600">
        <input
          type="text"
          readOnly
          value={url}
          className="flex-1 bg-transparent px-2 py-1 text-xs text-gray-800 dark:text-gray-100 select-all focus:outline-none"
          onFocus={(e) => e.target.select()}
        />
        <button
          onClick={() => {
            navigator.clipboard.writeText(url).then(() => {
              setCopied(true);
              onClose();
            });
          }}
          className="px-3 py-1 text-xs font-medium text-white bg-[#1D477F] hover:bg-[#163965] rounded-r-md"
        >
          {t("Kopyala")}
        </button>
      </div>
      {/* Geri bildirim etiketi */}
      {copied && (
        <div className="absolute -top-6 right-0 bg-green-600 text-white text-xs px-2 py-0.5 rounded shadow">
          Kopyalandı!
        </div>
      )}
    </div>
  );
};

export default ShareDropdown;
